import { render, staticRenderFns } from "./scorePart.vue?vue&type=template&id=348affbb&scoped=true&"
import script from "./scorePart.vue?vue&type=script&lang=js&"
export * from "./scorePart.vue?vue&type=script&lang=js&"
import style0 from "./scorePart.vue?vue&type=style&index=0&id=348affbb&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348affbb",
  null
  
)

export default component.exports